/**
 * @fileoverview Enumeration defining the types of methods used to verify an entity under an
 * external account
 *
 * @author Heesun Jun (hjun@yext.com)
 *
 */

/** @enum {string} */
export const VerificationMethod = {
  EMAIL: 'EMAIL',
  PHONE_CALL: 'PHONE_CALL',
  SMS: 'SMS',
  VIDEO: 'VIDEO',
  POSTCARD: 'POSTCARD',
  OTHER: 'OTHER',
  // Values below this only exist on the Javascript model and will map to null in backend Java
  SKIP: 'SKIP',
  CODE: 'CODE',
  DISABLED: 'DISABLED',
  PREVIOUSLY_VERIFIED: 'PREVIOUSLY_VERIFIED',
};

/**
 * Function to map VerificationMethod to its display name.
 * @param {VerificationMethod} verificationMethod
 * @return {string | undefined}
 */
export const getVerificationMethodDisplayName = verificationMethod => {
  switch (verificationMethod) {
    case VerificationMethod.SMS:
      return yext.msg('Text Message');
    case VerificationMethod.EMAIL:
      return yext.msg('Email');
    case VerificationMethod.PHONE_CALL:
      return yext.msg('Phone Call');
    case VerificationMethod.VIDEO:
      return yext.msg('Video');
    case VerificationMethod.POSTCARD:
      return yext.msg('Postcard');
    case VerificationMethod.DISABLED:
      // Currently the only reason verification can be disabled is if
      // Create New Listing was chosen
      return yext.msg('New Listing');
    case VerificationMethod.CODE:
      return yext.msg('I Have a Code');
    case VerificationMethod.PREVIOUSLY_VERIFIED:
      return yext.msg('Previously Verified');
    default:
      return undefined;
  }
};
